/* eslint-disable react/no-did-mount-set-state */
import React from 'react';
import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';
import { toast } from 'react-toastify';
import { Button, Table } from 'reactstrap';
import _orderBy from 'lodash/orderBy';

import AppComponent from './core/AppComponent';

import Loading from './core/Loading';
import Alert from './AlertRow';

class Alerts extends AppComponent {
  filterAlerts = (type, alerts) => {
    if (!alerts) {
      return [];
    }
    return alerts.filter(a => a.alertStatus === type);
  };

  render() {
    const { alertsQuery } = this.props;

    if (alertsQuery.loading) {
      return (
        <Loading />
      );
    }

    const { facilityAlerts = [] } = alertsQuery;

    return (
      <div>
        <h2 className="nightingale-text">
          Alerts
        </h2>

        <Table className="nightingale-Clients-FilterTable">
          <tbody>
            {
              facilityAlerts.length
                ? facilityAlerts.map(alert => <Alert key={alert.id} alert={alert} showName showRoom />)
                : <tr><td className="text-light text-center p-5" style={{ fontSize: 180 }}><span className="icon-bell" /></td></tr>
            }
          </tbody>
        </Table>

      </div>
    );
  }
}

const ALERTS_QUERY = gql`
    query($id: String!) {
        facilityAlerts(facilityId: $id, where: { alertStatus_not: RESOLVED }) {
            id
            alertStatus
            createdAt
            claimedAt
            claimedBy {
                name
            }
            confirmedAt
            confirmedBy {
                name
            }
            resolvedAt
            resolvedBy {
                name
            }
            resident {
                name
                roomNumber
            }
        }
    }
`;

export default compose(
  graphql(ALERTS_QUERY, {
    name: 'alertsQuery',
    options: props => {
      console.log('props alerts', props);
      return ({
      variables: {
        id: props.facilityId,
      },
      pollInterval: 5000,
    })},
  }),
)(Alerts);



// WEBPACK FOOTER //
// ./src/components/Alerts.js